(function() {

    function generateSimplePath(width, height) {
        var path = {};
        var data = [];
        for (var y = 0; y < height; y++) {
            data.push([]);
            for (var x = 0; x < width; x++) {
                if (y % 2 === 0) {
                    if (x === width - 1) {
                        data[y].push([x, y + 1]);
                    } else {
                        data[y].push([x + 1, y]);
                    }
                } else {
                    if (x === 0) {
                        data[y].push([x, y + 1]);
                    } else {
                        data[y].push([x - 1, y]);
                    }
                }
            }
        }

        path.start = [0, 0];
        if (y % 2 === 0) {
            path.end = [0, height - 1];
        } else {
            path.end = [width - 1, height - 1];
        }
        data[path.end[1]][path.end[0]] = [-1, -1];
        path.data = data;
        path.width = width;
        path.height = height;

        return path;
    }

    function step(hampath) {
        var s = hampath.start;
        var d = hampath.data;
        var w = d[0].length;
        var h = d.length;
        var dirs = [[0, -1], [1, 0], [0, 1], [-1, 0]];
        var dir;
        var validDir = false;


        while (!validDir) {
            validDir = true;
            dir = dirs[Math.floor(fxrand() * 4)];
            if (s[0] + dir[0] < 0 || s[0] + dir[0] > w - 1 || s[1] + dir[1] < 0 || s[1] + dir[1] > h - 1) {
                validDir = false;
            } else if (d[s[1]][s[0]][0] === s[0] + dir[0] && d[s[1]][s[0]][1] === s[1]) {
                validDir = false;
            }
        }

        var osd = [d[s[1]][s[0]][0], d[s[1]][s[0]][1]];

        d[s[1]][s[0]][0] = s[0] + dir[0];
        d[s[1]][s[0]][1] = s[1] + dir[1];

        var last = [s[0], s[1]];
        var curr = [s[0], s[1]];
        var next = [osd[0], osd[1]];
        while (next[0] !== s[0] + dir[0] || next[1] !== s[1] + dir[1]) {
            last[0] = curr[0];
            last[1] = curr[1];
            curr[0] = next[0];
            curr[1] = next[1];
            next[0] = d[curr[1]][curr[0]][0];
            next[1] = d[curr[1]][curr[0]][1];
            d[curr[1]][curr[0]][0] = last[0];
            d[curr[1]][curr[0]][1] = last[1];
        }
        s[0] = curr[0];
        s[1] = curr[1];
    }

    function reverse(path) {
        var s = path.start;
        var d = path.data;

        var last = [s[0], s[1]];
        var curr = [s[0], s[1]];
        var next = [d[s[1]][s[0]][0], d[s[1]][s[0]][1]];
        d[s[1]][s[0]][0] = -1;
        d[s[1]][s[0]][1] = -1;

        do {
            last[0] = curr[0];
            last[1] = curr[1];
            curr[0] = next[0];
            curr[1] = next[1];
            next[0] = d[curr[1]][curr[0]][0];
            next[1] = d[curr[1]][curr[0]][1];
            d[curr[1]][curr[0]][0] = last[0];
            d[curr[1]][curr[0]][1] = last[1];
        } while (next[0] !== -1 || next[1] !== -1);

        path.end[0] = path.start[0];
        path.end[1] = path.start[1];
        path.start[0] = curr[0];
        path.start[1] = curr[1];
    }

    function convertToSequence(path) {
        var d = path.data;
        var sequence = [];
        var curr = [path.start[0], path.start[1]];
        var next = [path.start[0], path.start[1]];
        do {
            curr[0] = next[0];
            curr[1] = next[1];
            sequence.push([curr[0], curr[1]]);
            next[0] = d[curr[1]][curr[0]][0];
            next[1] = d[curr[1]][curr[0]][1];
        } while (next[0] !== -1 || next[1] !== -1);
        path.data = sequence;
    }

    function generate(opts) {
        opts = opts || {};
        var w = opts.width || 8;
        var h = opts.height || 8;

        var path = generateSimplePath(w, h);

        var nSuccessful = 0;
        for (var i = 0; i < w * w * h * h * 0.1; i++) {
            if ((i + 1) % Math.max(w,h) === 0) {
                reverse(path);
            }
            step(path);
            nSuccessful++;
        }

        convertToSequence(path);

        return path;
    }

    window.hampath = {
        generate : generate,
    };

})();